export const appUrl = 'https://mosymphony.lupin.com';  
export const smlUrl = 'https://notary.schrocken.io';
export const AnalyticsKey = 'UA-171452508-1';
export const CaptchaSiteKey = '6Legf8oZAAAAAOxXKdJX-eBfOoHk5ppgUhRkUwZm';
export const azureADClientID = 'cb822f18-5d79-4768-8981-2f0389dfd38c';
export const azureADTenantID = 'a9c6fa70-d6e2-4563-adf3-0b24d921b140';
export const associateCMOsRoles = [8, 2, 31, 32, 19, 29, 40];
export const associateWarehouseRoles = [33];
